export default function Button({type, handler, className, children}){

  let bgStyle = 'bg-gray-900 hover:bg-sky-950';
  let textStyle = 'text-white';

  if(type === 'light'){
    bgStyle = 'bg-gray-300 hover:bg-gray-400';
    textStyle = 'text'
  }
  return (
    <button 
    className={`${className} px-4 py-1 lg:px-6 lg:py-2 ${textStyle} ${bgStyle} text-xs lg:text-base rounded`} 
    onClick={handler}>{children}</button>
  );
}